/*!
  * Furillo ajax-forms.js v2.0.0
  * Copyright 2023 Furillo Agency AB (https://www.furillo.se/)  
  */
import ajaxLoader from './ajax-loader.js';
export default class AjaxForms {
    
    static makeRequest(form) {

        const updateValidation = function (json) {
                        
            if (!json || !json.errors || json.errors.length === 0)
                return;

            json.errors.forEach((error) => {       

                /*console.log(error);*/

                const element = form.querySelector('[data-valmsg-for="' + error.propertyName + '"]');
                if (!element) {
                    console.warn('Validation error for property ' + error.propertyName + ' (' + error.errorMessage + ') but no validator element found!');
                    return true;
                }

                if (element.getAttribute('data-valmsg-replace') === 'true')
                    element.innerText = error.errorMessage;
                
                element.classList.remove('field-validation-valid');
                element.classList.add('field-validation-error');

                const field = form.querySelector('[name="' + element.getAttribute('data-valmsg-for') + '"]');
                if (!field) {
                    // There are cases where validation elements exists without an actual
                    // field behing present in the form, simply skip in that case.
                    return true;
                }

                field.classList.remove('valid');
                field.classList.add('input-validation-error');
            });
        };

        const resetValidation = function () {
            form.querySelectorAll('.field-validation-error').forEach((element) => {
                element.classList.add('field-validation-valid');
                element.classList.remove('field-validation-error');

                const field = form.querySelector('[name="' + element.getAttribute('data-valmsg-for') + '"]');
                if (!field) {
                    // There are cases where validation elements exists without an actual
                    // field behing present in the form, simply skip in that case.
                    return true;
                }

                field.classList.add('valid');
                field.classList.remove('input-validation-error');
            });
        };

        const base = this;
        const url = form.getAttribute('action');
        const method = form.getAttribute('method');
        const container = document.querySelector(form.getAttribute('data-ajax-update'));

        const formData = new FormData(form);
        //for (var pair of formData.entries()) {
        //    console.log(pair[0], pair[1]);
        //}

        if (!url || !method || !container) {
            return;
        }

        resetValidation();
        
        ajaxLoader.addLoader(container);

        fetch(url, {
            method: method,
            mode: 'same-origin',
            cache: 'no-cache',            
            body: formData
        }).then((response) => {
            if (response.status === 400) {
                response.json().then((json) => updateValidation(json));
                return null;
            }
            return response.text();
        }).then((html) => {
            ajaxLoader.removeLoader(container);
            
            if (!html)
                return;
            
            container.innerHTML = html;
        }).catch(function (err) {
            console.warn('Something went wrong.', err);
            ajaxLoader.removeLoader(container);
        });
    }


    static init(element) {
        const base = this;
        element.querySelectorAll('form[data-ajax="true"]').forEach(form => {

            form.addEventListener('submit', evt => {
                evt.preventDefault();
                base.makeRequest(evt.target)
            });
        });
    }
}




//export default function (element) {

//    const toggleLoader = function(container) {

//        let loader = container.querySelector('span.loader');
        
//        if (loader) {
//            container.remove();
//            return;
//        }

//        loader = document.createElement('span');
//        loader.classList.add('loader');

//        container.appendChild(loader);
//    }

//    var makeRequest = function (container) {
//        const url = container.getAttribute('data-ajax-url');
//        if (url && url.length > 0) {
//            toggleLoader(container);

//            fetch(url).then(function (response) {
//                return response.text();
//            }).then(function (html) {
//                container.innerHTML = html;
//            }).catch(function (err) {
//                console.warn('Something went wrong.', err);
//                toggleLoader(container);
//            });
//        }
//    };

//    element.querySelectorAll('div[data-ajax-url]').forEach(container => {
//        const autoLoad = container.getAttribute('data-ajax-autoload');
//        if (!autoLoad || autoLoad === 'true') {
//            makeRequest(container);
//        }
//    });
//}